<template>
    <div class="booker-bio">
        <div class="title-section">
            <p class="title">Let’s Get to Know You!</p>
            <p class="subtitle">
                Add a short bio to introduce yourself to the Hedlyner community.
            </p>
        </div>
        <form class="bio-form">
            <div class="textarea">
                <span
                    class="counter"
                    :class="
                        $v.userData.bio.bio.$dirty && !$v.userData.bio.bio.maxLength
                            ? 'error'
                            : ''
                    "
                >
                    {{ `${userData.bio.bio.length} / 500` }}
                </span>
                <textarea
                    name="long_biography"
                    v-model="$v.userData.bio.bio.$model"
                    placeholder="Whether you’re an artist, a booker, or a promoter, your story helps others connect with you. Share a bit about what makes you unique!"
                ></textarea>
            </div>
        </form>
    </div>
</template>
<script>
    import { required, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'BookerBio',
        props: {
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: true
            }
        },
        validations: {
            userData: {
                bio: {
                    bio: {
                        required,
                        maxLength: maxLength(500)
                    }
                }
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .booker-bio {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 40px;

        .title-section {
            color: #dedede;
            margin-top: 20px;
            .title {
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .subtitle {
                font-size: 16px;
            }
        }

        .error-msg {
            color: #ed3c0d;
            font-family: Instrument Sans;
            font-size: 8px;
            font-style: normal;
            font-weight: 600;
            line-height: 130%;
            letter-spacing: 0.14px;
        }

        .bio-form {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .textarea {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: flex-start;

                .counter {
                    color: #646464;
                    text-align: right;
                    @include base-font-12;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
                .error {
                    color: #ed3c0d;
                }

                textarea {
                    width: 100%;
                    height: 184px;
                    padding: 10px 12px;
                    border-radius: 8px;
                    border: 1px solid #8b8b8b;
                    background: inherit;
                    resize: none;
                    color: #dedede;
                    @include base-font-16;
                    line-height: 125%;
                }
                textarea::placeholder {
                    overflow: hidden;
                    color: #646464;
                    text-overflow: ellipsis;
                    @include base-font-16;
                    line-height: 125%;
                }
            }
        }
    }
</style>
